module.exports = __webpack_public_path__ + "img/feature_buy_en.63e7d5f9.png";